import { readStorage, STORAGE_KEYS, writeStorage } from '../../lib/storage';

export type ConsentDecision = 'granted' | 'denied';

export function readConsent(): ConsentDecision | null {
  const value = readStorage('local', STORAGE_KEYS.analyticsConsent);
  return value === 'granted' || value === 'denied' ? value : null;
}

export function saveConsent(decision: ConsentDecision): void {
  writeStorage('local', STORAGE_KEYS.analyticsConsent, decision);
}
